import React from 'react';
import Img from 'img';

import s from './container.module.scss';

export default React.forwardRef(
  (
    {
      children,
      className,
      noSection,
      primary,
      secondary,
      grey,
      image,
      blueOverlay,
      big,
      ...props
    },
    ref
  ) => {
    const primaryClasses = primary ? s.primary : '';
    const secondaryClasses = secondary ? s.secondary : '';
    const overlayClasses = blueOverlay ? s.blueOverlay : '';
    const greyClasses = grey ? s.grey : '';
    const colorClasses = primaryClasses || secondaryClasses || greyClasses;
    const classes = `${s.container} ${className || ''} ${colorClasses} ${
      image && !noSection ? s.hasImage : ''
    } ${big ? s.big : ''}`;
    return noSection ? (
      <div className={`container ${className || ''}`} ref={ref}>
        {children}
      </div>
    ) : (
      <section className={classes} {...props} ref={ref}>
        {image && (
          <div className={s.image}>
            {' '}
            <div className={s.imageWrapper}>
              <div className={`${s.overlay} ${overlayClasses} overlay`} />
              <Img src={image} className={s.img} />
            </div>
          </div>
        )}
        <div className="container">{children}</div>
      </section>
    );
  }
);
